module.exports = __webpack_public_path__ + "img/bg-banner-sp.41f7e624.png";